<template>
  <modal name="securone-resolve" class="modal-inner" transition="pop-out" :width="520" height="auto" :adaptive="true" :focus-trap="true" @opened="focusInput" @before-close="reset">
    <span class="close-button" @click="$modal.hide('securone-resolve')"><BaseIcon icon="times-circle" class="text-white" /></span>
    <div class="modal-header text-lg font-serif">{{ $t("securone.resolve.title") }}</div>
    <div class="modal-body" v-if="event">
      <div class="mb-4">
        <div class="text-base font-semibold text-secondary-800">{{ event.category.name }}</div>
        <div class="text-sm text-secondary-500 mt-1">
          {{ $t("securone.resolve.running_for", { time: elapsedSince(event.raisedAt || event.createdAt) }) }} ·
          {{ $t("securone.resolve.alerted", { n: event.recipientCount }) }} ·
          {{ $t("securone.resolve.acknowledged", { n: event.acknowledgedCount }) }}
        </div>
      </div>

      <form @submit.prevent="submit">
        <label for="securone-access-code" class="block text-xs font-semibold uppercase tracking-wide text-secondary-500 mb-2">{{ $t("securone.resolve.your_code") }}</label>
        <!-- Underlined text field: letters and digits, not a numeric keypad. -->
        <input
          id="securone-access-code"
          ref="input"
          v-model="code"
          type="text"
          inputmode="text"
          autocomplete="off"
          autocapitalize="characters"
          spellcheck="false"
          maxlength="50"
          class="so-codein font-mono text-xl tracking-widest bg-transparent border-b-2 focus:outline-none py-1"
          :class="bad ? 'border-red-500 text-red-700' : 'border-secondary-400 focus:border-securdia-blue text-secondary-900'"
          placeholder="······"
        />
        <div class="text-xs mt-2" :class="bad ? 'text-red-600' : 'text-secondary-500'">
          {{ bad ? $t("securone.resolve.wrong_code") : $t("securone.resolve.code_hint") }}
        </div>
      </form>

      <SoNote tone="muted" icon="lock" class="mt-4">{{ $t("securone.resolve.consequence") }}</SoNote>
      <SoNote v-if="error" tone="bad" class="mt-3">{{ error }}</SoNote>
    </div>
    <div class="modal-footer">
      <div class="footer-container flex items-center gap-3">
        <button class="sd-btn sd-btn--secondary" @click="$modal.hide('securone-resolve')">{{ $t("securone.common.cancel") }}</button>
        <span class="flex-1"></span>
        <button class="sd-btn sd-btn--danger" :disabled="!code.trim() || busy" @click="submit"><BaseIcon icon="lock" class="mr-1" />{{ $t("securone.resolve.resolve") }}</button>
      </div>
    </div>
  </modal>
</template>

<script>
import SoNote from "./SoNote.vue";
import api from "../securone.api";
import { tickerMixin, errorMessage } from "../securone.helpers";

// D-43 / D-28. A wrong code keeps the event open and is logged server-side.
export default {
  name: "ResolveModal",
  components: { SoNote },
  mixins: [tickerMixin],
  data() {
    return { event: null, code: "", bad: false, busy: false, error: null };
  },
  methods: {
    open(event) {
      this.reset();
      this.event = event;
      this.$modal.show("securone-resolve");
    },
    reset() {
      this.code = "";
      this.bad = false;
      this.busy = false;
      this.error = null;
    },
    focusInput() {
      this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
    },
    async submit() {
      const code = this.code.trim();
      if (!code || this.busy) return;
      this.busy = true;
      this.error = null;
      try {
        const resolved = await api.resolve(this.event._id, code);
        this.$modal.hide("securone-resolve");
        this.$emit("resolved", resolved);
      } catch (error) {
        const errorId = error && error.response && error.response.data ? error.response.data.errorId : null;
        if (errorId === "wrong_access_code") {
          this.bad = true;
          this.focusInput();
        } else {
          this.error = errorMessage(this, error);
        }
      } finally {
        this.busy = false;
      }
    },
  },
  watch: {
    code() {
      this.bad = false;
    },
  },
};
</script>
